module.exports = __webpack_public_path__ + "img/exe.7c5263f8.png";